import { Button, Flex, Icon, Text } from '@pega/cosmos-react-core';
import React from 'react';
import { useSelector } from 'react-redux';
import useLocalTranslation from '../../../../../hooks/useLocalTranslation';
import { appState } from '../../../../../interfaces/common';

interface ChatContainerProps {
  selectedColors: any;
  isExpanded: boolean;
  expandedToggle: () => void;
}

const ChatToggle: React.FC<ChatContainerProps> = ({ selectedColors, isExpanded, expandedToggle }) => {
  const {
    chatInfo: { widgetButtonText, widgetButtonType, colorTheme },
  } = useSelector((state: appState) => {
    return {
      chatInfo: state.chatInfo,
    };
  });
  const translate = useLocalTranslation();
  const showIconButton = widgetButtonType !== 'text' || isExpanded;

  const toggleButtonStyle = {
    height: 40,
    width: showIconButton ? 40 : 'max-content',
    color: '#FFFFFF',
    backgroundColor: selectedColors?.selectedColorTheme || colorTheme,
  };

  const updateToggleState = () => {
    expandedToggle();
  };

  return (
    <Flex>
      <Button
        variant="primary"
        onClick={updateToggleState}
        icon={showIconButton}
        style={toggleButtonStyle}
        title={isExpanded ? translate('minimize_chat') : translate('open_chat')}
      >
        {showIconButton ? <Icon name={isExpanded ? 'caret-down' : 'chats-solid'} /> : <Text>{widgetButtonText}</Text>}
      </Button>
    </Flex>
  );
};

export default ChatToggle;
